var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(
            _vm._s(
              _vm.$t("BusinessStockDistributionQtyViewForm.basicInformation")
            ) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", size: "mini" },
                  on: { click: _vm.reFresh },
                },
                [_vm._v(_vm._s(_vm.$t("refreshText")))]
              ),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        { ref: "form", staticClass: "gray", attrs: { model: _vm.form } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyViewForm.supportName"
                        ),
                      },
                    },
                    [_c("span", [_vm._v(" " + _vm._s(_vm.form.supportName))])]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyViewForm.supportTypeMeaning"
                        ),
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.form.supportTypeMeaning)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyViewForm.supportCode"
                        ),
                      },
                    },
                    [
                      _vm._v(": "),
                      _c("span", [_vm._v(" " + _vm._s(_vm.form.supportCode))]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyViewForm.receiveName"
                        ),
                      },
                    },
                    [_c("span", [_vm._v(" " + _vm._s(_vm.form.receiveName))])]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyViewForm.receiveTypeMeaning"
                        ),
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.form.receiveTypeMeaning)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyViewForm.receiveCode"
                        ),
                      },
                    },
                    [_c("span", [_vm._v(" " + _vm._s(_vm.form.receiveCode))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(
              _vm.$t("BusinessStockDistributionQtyViewForm.commodityDetails")
            ) + " "
          ),
          !_vm.isView
            ? [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.showAddSkuDialog },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionQtyViewForm.selectGoods"
                        )
                      )
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("BjPagingTable", {
        ref: "BjPagingTable",
        attrs: {
          "auto-fetch": false,
          api: _vm.tableApi,
          "default-params": {
            receiveWarehouseId: _vm.form.receiveWarehouseId,
            supportWarehouseId: _vm.form.supportWarehouseId,
          },
          "reset-data": _vm.resetData,
          "before-modify-paging-info": _vm.beforeModifyPagingInfo,
        },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    width: "60",
                    align: "center",
                    label: _vm.$t("table.countText"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "categoryName",
                    label: _vm.$t(
                      "BusinessStockDistributionQtyViewForm.table.categoryName"
                    ),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "skuCode",
                    label: _vm.$t(
                      "BusinessStockDistributionQtyViewForm.table.skuCode"
                    ),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "qty",
                    label: _vm.$t(
                      "BusinessStockDistributionQtyViewForm.table.qty"
                    ),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          !_vm.isView && _vm.isModifyRow(props.row)
                            ? _c("BjInput", {
                                attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT },
                                model: {
                                  value: props.row.qty,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "qty", $$v)
                                  },
                                  expression: "props.row.qty",
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(props.row.qty))]),
                        ]
                      },
                    },
                  ]),
                }),
                !_vm.isView
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "action",
                        label: _vm.$t("table.operationText"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isModifyRow(props.row),
                                        expression: "!isModifyRow(props.row)",
                                      },
                                    ],
                                    staticClass: "delete-btn",
                                    attrs: {
                                      disabled: !props.row.id,
                                      type: "text",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDelete(
                                          props.row,
                                          props.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("delText")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isModifyRow(props.row),
                                        expression: "!isModifyRow(props.row)",
                                      },
                                    ],
                                    staticClass: "edit-btn",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEdit(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("editText")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isModifyRow(props.row),
                                        expression: "isModifyRow(props.row)",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onSave(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("saveText")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isModifyRow(props.row),
                                        expression: "isModifyRow(props.row)",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onCancel(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("cancelText")))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2832186201
                      ),
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isView
        ? [
            _c("BjDivider", [
              _vm._v(
                _vm._s(
                  _vm.$t("BusinessStockDistributionQtyViewForm.operationLog")
                ) + " "
              ),
            ]),
            _c("BjLogTable", { attrs: { "table-data": _vm.info.logList } }),
          ]
        : _vm._e(),
      _c("BjDialogList", {
        ref: "dialogListGoods",
        attrs: {
          config: _vm.dialogListGoodsConfig,
          "row-keys": "skuCode",
          disabled: _vm.disabledIds,
          multiple: "",
        },
        on: { confirm: _vm.onConfirmDialogListGoods },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }